<template>
  <el-row class="ecm__books_component" :gutter="10">
    <el-col :span="3"
      v-for="book in books" :key="book.id"
    >
      <Card
        :book="book"
      />  
    </el-col>
  </el-row>
</template>

<script>
import Card from '@/components/Card.vue'

export default {
  name: 'Books_Component',
  components: {
    Card
  },
  props: {
    books: {
      type: Array,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__books_component {
  margin-bottom: 20px;
  .el-col {
    margin-bottom: 10px;
  }
}
</style>
